<div>
    <div class="flex align-items-center justify-content-center mt-3">
        <div class="search-section">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
                <input pInputText type="text" [(ngModel)]="searchKey" placeholder="Search.." class="p-inputtext-sm" (keyup.enter)="search()"/>
                  <p-button icon="pi pi-search" (onClick)="search()" [style]="{'margin': '5px', 'height': '35px', 'line-height': '50px'}" [raised]="true" [size]="'small'" severity="info"></p-button>
             </span>
           </div>
    </div>
    <p-table #dt1 [value]="products" [scrollable]="true" scrollHeight="350px" styleClass="p-datatable-striped" [loading]="loader" paginatorDropdownAppendTo="body"
        responsiveLayout="scroll" class="w-full m-5" styleClass="p-datatable-sm " [paginator]="true" [rows]="5" selectionMode="single" (onPage)="load($event)"
        (onRowSelect)="onSelect($event)" [rowsPerPageOptions]="[5, 10, 20]">

        <ng-template pTemplate="header">
            <tr>
                <th></th>
                <th>Product Code</th>
                <th>Product Name</th>
                <th>Price</th>
                <th>UOM</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr (click)="onSelect(data)">
              <td><p-tableRadioButton [value]="data"></p-tableRadioButton></td>
                <td>{{data.productCode}}</td>
                <td>{{data.productName}}</td>
                <td>{{data.salesPrice}}</td>
                <td>{{data.unitsOfMeasure}}</td>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="4">No Records found.</td>
            </tr>
        </ng-template>
    </p-table>
</div>